import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Button from '@mui/material/Button';

export default function PreviewComponent({
  activeStep,
  steps,
  compileTemplate,
  handleClickPDFDownload,
  handleTemplateDownload,
  printRef,
  compiledTemplate,
}) {
  return (
    <div
      style={{
        maxHeight: `900px`,
        minHeight: '900px',
        display: 'flex',
        flexDirection: 'column',
        border: '5px solid',
        borderColor: '#f4f7f9',
        borderRadius: '10px',
      }}
    >
      <div
        style={{
          display: activeStep > steps.length - 2 ? 'none' : 'flex',
          backgroundColor: '#f4f7f9',
          marginBottom: '1px',
          borderRadius: '5px',
        }}
      >
        <MoreHorizIcon sx={{ margin: '3px', color: '#cfd9e3' }} />
        <Button
          variant="text"
          onClick={compileTemplate}
          size="small"
          sx={{
            marginLeft: 'auto',
            marginRight: '25px',
          }}
        >
          Preview
        </Button>
      </div>
      <div
        style={{
          display: activeStep === steps.length - 1 ? 'flex' : 'none',
        }}
      >
        <Button
          variant="text"
          onClick={handleClickPDFDownload}
          sx={{
            marginLeft: 'auto',
            marginRight: '10px',
          }}
        >
          Download as PDF
        </Button>
        <Button variant="text" onClick={handleTemplateDownload} sx={{}}>
          Download as HTML
        </Button>
      </div>
      <div
        ref={printRef}
        style={{
          width: '100%',
          maxHeight: activeStep === steps.length - 1 ? '100%' : `900px`,
          minHeight: '600px',
          overflow: 'auto',
        }}
      >
        {ReactHtmlParser(compiledTemplate)}
      </div>
    </div>
  );
}
